var orderHistoryId = $("#initStoreId").val();
var dataSourceId = $("#DataSourceId").val();

function dismissLastOrderOverlay() {
    subwayScript.setCookie('recentOrderOverlay', "false", 90);
    $('.recent-order-overlay').hide();
    analytics.recentOrdersDismiss();
}

if ($('#frmLastOrder').length) {
    (function () {
        'use strict';
        var $form = $('#frmLastOrder');

        $(function () {
            var action = $form[0].action;
            ajaxGetResults(action, $form);
            disPlayDefaultStoreHeader()

        });

        function ajaxGetResults(postUrl, form) {
            $.ajax({
                url: postUrl,
                type: 'POST',
                data: form.serialize(),
                success: function (data) {
                    if (data !== null && data !== '') {
                        $('#frmLastOrder').html(data);
                        //set default store data to session.
                        setDefaultStoreDataToSession()
                        if ($('.order-status').html() != undefined && $('.order-status').html() == 'Order Completed') {
                            analytics.getOrderStatus($('.order-status').html());
                        }

                        else if ($('.order-status').html() != undefined && $('.order-status').html() != 'Order Completed') {
                            analytics.getOrderStatus($('.order-status').html());
                        }
                        else {
                            analytics.getOrderStatus('');
                        }
                    }
                    $('.last-order-carousel').slick({
                        dots: true,
                        arrows: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 400,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }

                        ]
                    });
                    if ($('.last-order-carousel .slick-slide:not(.slick-cloned)').length > 1) {
                        $('#slick-total-order').text($('.last-order-carousel .slick-slide:not(.slick-cloned)').length);
                        $('#slick-order-count').text($('.last-order-carousel .slick-dots li.slick-active button').text());
                    }
                    //Prev
                    $('#slickPrevOrder').on('click', function () {
                        $('.last-order-carousel').slick('slickPrev');
                        $('#slick-order-count').text($('.last-order-carousel .slick-dots li.slick-active button').text());

                    })
                    $('.last-order-carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        $('#slick-order-count').text($('.last-order-carousel .slick-dots li.slick-active button').text());

                    });
                    //Next
                    $('#slickNextOrder').on('click', function () {
                        $('.last-order-carousel').slick('slickNext');
                        $('#slick-order-count').text($('.last-order-carousel .slick-dots li.slick-active button').text());
                    })
                    const getCtaText = $('#lastorderReorder').text().trim();
                    if (getCtaText === 'RE-ORDER' || getCtaText === 'COMMANDER DE NOUVEAU') {
                        if (subwayScript.getCookie('recentOrderOverlay') == "" || subwayScript.getCookie('recentOrderOverlay') == "true") {
                            subwayScript.setCookie('recentOrderOverlay', "true", 90);
                            $('.recent-order-overlay').show();
                            $(".recent-order-overlay img").trigger('focus');
                            $(document).on('keyup', function (evt) {
                                if (evt.keyCode == 27) {
                                    dismissLastOrderOverlay();
                                }
                            });
                        }
                    }
                    $('.recent-order-overlay button').on('click', function () {
                        dismissLastOrderOverlay();
                    })

                },
                error: function (jqXhr) {
                    // To handle time out error or any other errors

                }
            });
        }

    })();
}

function setDefaultStoreDataToSession(storeData) {
    if (storeData && storeData.StoreId && $('#defaultStoreHeader').length > 0) {
        const details = storeData;
        const deliveryLdFlag = client.variation(FF_FULFILLMENT_TYPE_DELIVERY,true);
        const curbsideLdFlag = client.variation(FF_FULFILLMENT_TYPE_CURBSIDE,true);
        if (!orderViewModel.store.id || !orderViewModel.currentOrder.cartId) {
            const storeId = details.StoreId
            const orderType = details.FulfillmentType || ''
            if (orderType.toLowerCase() == 'delivery') {
                if(!deliveryLdFlag) return 0;
                $('#defaultStoreHeader').removeClass('d-none') 
                $('#defaultStoreHeader a').attr('href', subwayScript.navigation.getDeliveryLocatorUrl())
                $('#defaultStoreHeader img').attr('src', "/Assets/RemoteOrder/img/05-ui-icon-24-px-delivery@3x.PNG")
                $('#defaultStoreHeader span').text($('#deliveryToText').val())
                const address = details.Delivery && details.Delivery.DeliveryAddress.Address1 || ''
                orderViewModel.store.address1 = address
                $('#defaultStoreHeader a').text(address)
                deliveryAddressAvaliablity(details.Delivery.DeliveryAddress)
            } else {
                if (orderType.toLowerCase() === 'curbside') {
                    if(!curbsideLdFlag) return 0;
                    $('#defaultStoreHeader span').text($('#curbsidepickupText').val());
                } else {
                    $('#defaultStoreHeader span').text($('#pickupOnlyText').val());
                }
                $('#defaultStoreHeader').removeClass('d-none')
                $('#defaultStoreHeader a').attr('href', subwayScript.navigation.getLocatorUrl())
                $('#defaultStoreHeader img').attr('src', "/Assets/RemoteOrder/img/05-ui-icon-pickup@3x.png")
                
                orderViewModel.defaultStoreDetails = {}
                orderViewModel.defaultStoreDetails.fromDefaultStoreforCurbside = true;
                orderViewModel.save()
                orderViewModel.store.address1 = details.Address
                $('#defaultStoreHeader a').text(details.Address)
                $('#globalHeader .start-order-btn').on('click', showModalId_startOrderClick)
                $('#homeStartorderOnlyFooter .start-order-btn').on('click', showModalId_startOrderClick)
                createCartInCategories(storeId, true, orderType.toLowerCase())
            }
            const url = subwayScript.navigation.getMenuUrl(storeId)
            $('.navbar_right .start_order').attr('href', url);
            if (storeId) {
                $("button.start_order").attr('onclick', "engageApptentiveEvent('Start Order',true,'" + url + "');sendClickInfoToAnalyticsCMS('header', 'default', 'Start Order', 'start order', '', '', event)");
            }
            $('#globalHeader .start-order-btn').attr('href', url)
            $('#homeStartorderOnlyFooter .start-order-btn').attr('href', url)
            $('.start_order #orderType').attr('href', url);

        }
        else {
            if (orderViewModel.orderType == 'delivery') {
                if(!deliveryLdFlag){
                    orderViewModel.store.id = null;
                    orderViewModel.store.StoreId = null;
                    orderViewModel.orderType=''
                    return 0;
                }
                $('#defaultStoreHeader a').attr('href', subwayScript.navigation.getDeliveryLocatorUrl())
                $('#defaultStoreHeader img').attr('src', "/Assets/RemoteOrder/img/05-ui-icon-24-px-delivery@3x.PNG")
                $('#defaultStoreHeader span').text($('#deliveryToText').val())
                $('#defaultStoreHeader a').text(orderViewModel.DeliveryAddress.StreetAddressLine1)
            } else {
                if (orderViewModel.orderType === 'curbside') {
                    if(!curbsideLdFlag){
                        orderViewModel.store.id = null;
                        orderViewModel.store.StoreId = null;
                        orderViewModel.orderType=''
                        return 0;
                    }
                    $('#defaultStoreHeader span').text($('#curbsidepickupText').val());
                } else {
                    $('#defaultStoreHeader span').text($('#pickupOnlyText').val());
                }
                $('#defaultStoreHeader img').attr('src', "/Assets/RemoteOrder/img/05-ui-icon-pickup@3x.png")
                $('#defaultStoreHeader a').attr('href', subwayScript.navigation.getLocatorUrl())
                $('#defaultStoreHeader a').text(orderViewModel.store.address1)
            }

            $('#defaultStoreHeader').removeClass('d-none')
        }
        var marginTop = $('.navbar.cms').outerHeight() + $('.defaultStoreHeader').outerHeight();
        $('.body-top-margin').css({ "margin-top": `${marginTop}px` });
    }
}
function disPlayDefaultStoreHeader() {
    if (orderViewModel.store.id) {
        if (orderViewModel.orderType == 'delivery') {
            $('#defaultStoreHeader img').attr('src', "/Assets/RemoteOrder/img/05-ui-icon-24-px-delivery@3x.PNG")
            $('#defaultStoreHeader span').text($('#deliveryToText').val())
            $('#defaultStoreHeader a').attr('href', subwayScript.navigation.getDeliveryLocatorUrl())
            $('#defaultStoreHeader a').text(orderViewModel.DeliveryAddress.StreetAddressLine1)
        } else {
            if (orderViewModel.orderType === 'curbside') {
                $('#defaultStoreHeader span').text($('#curbsidepickupText').val())
            } else {
                $('#defaultStoreHeader span').text($('#pickupOnlyText').val())
            }
            $('#defaultStoreHeader a').attr('href', subwayScript.navigation.getLocatorUrl())
            $('#defaultStoreHeader img').attr('src', "/Assets/RemoteOrder/img/05-ui-icon-pickup@3x.png")
            $('#defaultStoreHeader a').text(orderViewModel.store.address1)
        }

        $('#defaultStoreHeader').removeClass('d-none')
    }
}

function onClickSubCategory(event, subCat) {
    if (subCat) {
        orderViewModel.subCategory = subCat;
        orderViewModel.save();

    }

    event.currentTarget.previousElementSibling == null ? subwayScript.setCookie('productBadgeText', "", 1) : subwayScript.setCookie('productBadgeText', event.currentTarget.previousElementSibling.innerText, 1);
}
function deliveryAddressAvaliablity(details) {
    subwayScript.showSpinner();
    const addressData = {
        StreetAddressLine1: details.Address1,
        StreetAddressLine2: details.Address2,
        City: details.City,
        State: details.State,
        Zip: details.Zipcode,
        Country: details.Country
    };
    $.ajax({
        url: $('#DeliveryTimeEstimation').attr('action'),
        type: 'POST',
        data: addressData,
        success: function (response) {
            if (response.error) {
                subwayScript.showAjaxError(response);
            } else if (!response.hasOrderType) {
                modalShowId('#orderTypeModal');
            } else if (!response.isWebOrderAvailable) {
                modalShowId('#modal-web-order-not-available');
            } else if (!response.isStoreOpen) {
                var title = $('.delivery-error-modal-title').text(response.ErrorCodeTitle.trim());
                var body = $('.delivery-error-modal-subtitle').text(response.ErrorCodeMessage.trim());
                $("#modalDeliveryLocationError").show();
                modalShowId('#modalDeliveryLocationError');
                analytics.pageError(title, body, 'n/a', 'n/a', false);
            }
            else {

                if (response.deliveryTimeRangeMin != null && response.deliveryTimeRangeMax != null) {
                    orderViewModel.store.id = response.storeId;
                    orderViewModel.DeliveryAddress.StreetAddressLine1 = addressData.StreetAddressLine1;
                    orderViewModel.DeliveryAddress.StreetAddressLine2 = addressData.StreetAddressLine2;
                    orderViewModel.DeliveryAddress.City = addressData.City;
                    orderViewModel.DeliveryAddress.State = addressData.State;
                    orderViewModel.DeliveryAddress.Zip = addressData.Zip;
                    orderViewModel.DeliveryAddress.Country = addressData.Country;
                    orderViewModel.DeliveryAddress.DirectDelivery = true;
                    orderViewModel.DeliveryAddress.QuoteId = response.quoteId;
                    orderViewModel.orderType = 'delivery';
                    orderViewModel.DeliveryAddress.fromDefaultStore = false;
                    orderViewModel.AnalyticsorderType = getOrderTypeByFulfillmentType('delivery');
                    orderViewModel.save()
                    createDeliveryCart(true)
                    hideLanguageFromDropdown();

                }
            }
            subwayScript.hideSpinner()
        },
        error: function (jqXhr) {

            let msg = ''
            if (jqXhr.responseJSON && jqXhr.responseJSON.error && jqXhr.responseJSON.error.message) {
                const errorCode = jqXhr.responseJSON.error.errorCode || 'n/a';
                msg = jqXhr.responseJSON.error.message.trim();
                analytics.deliveryErrorPopUp(msg, errorCode);
            }
            orderViewModel.defaultStoreDetails = {}
            orderViewModel.defaultStoreDetails.orderType = 'delivery'
            orderViewModel.DeliveryAddress.fromDefaultStore = true;
            orderViewModel.DeliveryAddress.errorMessage = msg;
            orderViewModel.DeliveryAddress.formattedAddress = details.Address1 + ', ' + details.City + ', ' + details.State + ' ' + details.Zipcode + ', ' + details.Country
            orderViewModel.save();
            const url = subwayScript.navigation.getDeliveryLocatorUrl();
            //go to delivery locator page and show error in page
            $("button.start_order").attr('onclick', "engageApptentiveEvent('Start Order',true,'" + url + "');sendClickInfoToAnalyticsCMS('header', 'default', 'Start Order', 'start order', '', '', event)");
            $(".component_footer .horizontal_footer .start_order button").click(function(){ engageApptentiveEvent('Start Order',true, url)})
            subwayScript.hideSpinner()
        }
    });
}

function showModalId_startOrderClick() {
    if (showModalId !== '') {
        var title = $(showModalId).find('.error-title').text() || $(showModalId).find('.head-txt').text();
        var body = $(showModalId).find('.error-body').text() || $(showModalId).find('.body-txt').text();
        if (title !== '') analytics.pageError(title, body, 'n/a', 'n/a', false);
        $('#globalHeader .start-order-btn').attr('href', '#')
        $('#homeStartorderOnlyFooter .start-order-btn').attr('href', '#')
        modalShowId(showModalId);



    }
}